import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import welcomeIcon from '../../assets/WelcomeIcon.svg';
import { useHistory } from 'react-router-dom';
import { UserPortalContext } from '../../context/appcontext';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';

const useStyles = makeStyles({
	topHeader: {
		fontWeight: 'normal',
		fontSize: 40,
		textAlign: 'center',
		color: 'rgba(0, 0, 0, 0.87)',
	},
	modalbody: {
		fontFamily: 'Bogle-Regular',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: 20,
		textAlign: 'center',
		color: 'rgba(0, 0, 0, 0.87)',
		lineHeight: '27.8px',
		marginTop: 20,
	},
	button: {
		background: '#3C228A',
		borderRadius: 74,
		height: 40,
		color: '#FFFFFF',
		width: 151,
		'&:hover': {
			backgroundColor: '#3C228A',
		},
	},
	wrapper: {
		width: 880,
		height: 435,
		background: '#FFFFFFFF',
		p: 4,
		border: '1px solid #DADCE0',
		boxShadow: '0px 0px 10px rgba(51, 51, 51, 0.1)',
		borderRadius: '8px',
		padding: '24px 40px',
		overflow: 'auto',

		'@media (max-width: 1024px)': {
			width: '100%',
			margin: '16px',
			height: '490px',
			display: 'grid',
			justifyContent: 'center',
			padding: '24px 8px',
		},
		'@media (max-width:460px)': {
			height: 'auto',
		},
		'@media (max-width:360px)': {
			'& div:first-child': {
				fontSize: 32,
			},
			border: 'none',
			boxShadow: 'none',
			height: 'auto',
			padding: '24px 16px',
			margin: '16px 0px',
		},

		'@media (min-width: 769px)': {
			padding: '24px 56px',
		},

		'@media(min-width: 460px ) and (max-width: 769px)': {
			height: '515px',
		},
	},
});

function Welcome() {
	const portalUserContext = React.useContext(UserPortalContext);
	let fName = portalUserContext?.result?.firstName;
	//Turn first letter capital
	fName = fName && `, ${fName[0].toUpperCase()}${fName.slice(1)}`;
	const classes = useStyles();
	const navigate = useHistory();

	useEffect(() => {
		analytics.trackPageInfo(tracker.PAGE_ID.WELCOME);
	}, []);

	return (
		<div style={{ height: '100vh' }}>
			<Grid
				container
				style={{ height: '100%' }}
				alignItems="center"
				justifyContent="center">
				<Grid className={classes.wrapper}>
					<div className={classes.topHeader}>Welcome{fName}</div>
					<div className={classes.modalbody} style={{ marginTop: 2 }}>
						Channel Performance is our new tool for surfacing insights from your
						sales & inventory data. We give you access to in-store and online
						data from the 1,000 ft view, all the way down to the item. Let’s get
						started by customizing your dashboards.
					</div>
					<Box display="flex" justifyContent="center" mt={3}>
						<Grid container justifyContent="center">
							<img src={welcomeIcon} alt="Channel partner"></img>
						</Grid>
					</Box>
					<Box display="flex" justifyContent="center" mt={4}>
						<Button
							onClick={() => {
								navigate.push('/dashboard');
							}}
							className={classes.button}
							style={{ textTransform: 'none' }}>
							Let’s get started!
						</Button>
					</Box>
				</Grid>
			</Grid>
		</div>
	);
}

Welcome.propTypes = {};

export default Welcome;
